/* eslint-disable */

export const createClient = /* GraphQL */ `
  mutation CreateClient(
    $input: CreateClientInput!
    $condition: ModelClientConditionInput
  ) {
    createClient(input: $input, condition: $condition) {
      client_id
      client_full_name
      jira_project_name
      client_type
      is_active
      is_advantage_member
      is_strategy_partner
      is_mid_level_member
      exclude_from_match_qualifier
      featurize
      people_platform
      action_platform
      transaction_platform
      exhaust_platform
      sms_platform
      transactions_offline_platform
      curate_subscriber
      curate_frequency
      curate_days
      curate_delivery_auto_upload
      suppressed_domains
      actblue_entity_ids
      sfg_surveys_client_ids
      goop_client_ids
      totem_client_ids
      salsa_organization_key
      ngp_everyaction_database_name
      ngp_everyaction_server_name
      numero_account_ids
      salesforce_location
      pardot_location
      hub_source_path
      facebook_account_ids
      facebook_locations
      google_account_ids
      bing_account_ids
      twitter_account_ids
      outbrain_account_ids
      code_dictionary_url
      annelewis_slack_channel
      timezone
      mailchimp_directory
      classy_org_id
      ngp_actblue_manual_codes
      share_cap_max_shares
      share_cap_months
      hubspot_stitch_integration_name
      tatango_client_id
      inbox_monster_rule
      campaign_monitor_location
      pause_data
      email_validation_provider
      multi_member_clients
      multi_member_sms_clients
      multi_member_mid_level_clients
      stw_subaccount_ids
      stw_non_coop_subaccount_ids
      switchboard_dataset_name
      notes
      is_low_inventory
      fiscal_year_start
      multi_member_required
      multi_member_mid_level_required
      sector
      vendor
      email_configurations
      sms_configurations
      is_ads_reporting_active
      ads_configuration
      ads_commissions
      identity
      createdAt
      updatedAt
    }
  }
`;
export const updateClient = /* GraphQL */ `
  mutation UpdateClient(
    $input: UpdateClientInput!
    $condition: ModelClientConditionInput
  ) {
    updateClient(input: $input, condition: $condition) {
      client_id
      client_full_name
      jira_project_name
      client_type
      is_active
      is_advantage_member
      is_strategy_partner
      is_mid_level_member
      exclude_from_match_qualifier
      featurize
      people_platform
      action_platform
      transaction_platform
      exhaust_platform
      sms_platform
      transactions_offline_platform
      curate_subscriber
      curate_frequency
      curate_days
      curate_delivery_auto_upload
      suppressed_domains
      actblue_entity_ids
      sfg_surveys_client_ids
      goop_client_ids
      totem_client_ids
      salsa_organization_key
      ngp_everyaction_database_name
      ngp_everyaction_server_name
      numero_account_ids
      salesforce_location
      pardot_location
      hub_source_path
      facebook_account_ids
      facebook_locations
      google_account_ids
      bing_account_ids
      twitter_account_ids
      outbrain_account_ids
      code_dictionary_url
      annelewis_slack_channel
      timezone
      mailchimp_directory
      classy_org_id
      ngp_actblue_manual_codes
      share_cap_max_shares
      share_cap_months
      hubspot_stitch_integration_name
      tatango_client_id
      inbox_monster_rule
      campaign_monitor_location
      pause_data
      email_validation_provider
      multi_member_clients
      multi_member_sms_clients
      multi_member_mid_level_clients
      stw_subaccount_ids
      stw_non_coop_subaccount_ids
      switchboard_dataset_name
      notes
      is_low_inventory
      fiscal_year_start
      multi_member_required
      multi_member_mid_level_required
      sector
      vendor
      email_configurations
      sms_configurations
      is_ads_reporting_active
      ads_configuration
      ads_commissions
      identity
      createdAt
      updatedAt
    }
  }
`;

export const createSources = /* GraphQL */ `
  mutation CreateSources(
    $input: CreateSourcesInput!
    $condition: ModelSourcesConditionInput
  ) {
    createSources(input: $input, condition: $condition) {
      id
      createdAt
      client_id
      channel_category
      source
      from_goop
      send_date
      updatedAt
    }
  }
`;
export const updateSources = /* GraphQL */ `
  mutation UpdateSources(
    $input: UpdateSourcesInput!
    $condition: ModelSourcesConditionInput
  ) {
    updateSources(input: $input, condition: $condition) {
      id
      createdAt
      client_id
      channel_category
      source
      from_goop
      send_date
      updatedAt
    }
  }
`;
export const deleteSources = /* GraphQL */ `
  mutation DeleteSources(
    $input: DeleteSourcesInput!
    $condition: ModelSourcesConditionInput
  ) {
    deleteSources(input: $input, condition: $condition) {
      id
      createdAt
      client_id
      channel_category
      source
      from_goop
      send_date
      updatedAt
    }
  }
`;

export const updateCodes = /* GraphQL */ `
  mutation UpdateCodes(
    $input: UpdateCodesInput!
    $condition: ModelCodesConditionInput
  ) {
    updateCodes(input: $input, condition: $condition) {
      id
      createdAt
      client_id
      code
      source
      channel
      send_cost
      send_size
      fixed_cost_media_spend
      fixed_cost_cpa_override
      revenue_category
      audience
      audience_category
      type
      platforms_with_spend
      total_spend
      most_recent_spend
      most_recent_spend_date
      most_recent_transaction_date
      revenue
      transactions
      acquisitions
      most_recent_acquisition_date
      from_goop
      updatedAt
      version
      jira_ticket_num
    }
  }
`;

export const updateTransactions = /* GraphQL */ `
  mutation UpdateTransactions(
    $input: UpdateTransactionsInput!
    $condition: ModelTransactionsConditionInput
  ) {
    updateTransactions(input: $input, condition: $condition) {
      id
      client_id
      email
      code
      amount
      transaction_dt
      recurring_period
      recurrence
      recurring_type
      refund_flag
      exclude_flag
      exclusion_updated_dt
      foreign_platform
      foreign_client_key
      foreign_transaction_key
      mobile_flag
      updated_dt
      createdAt
      updatedAt
    }
  }
`;

export const createSumBySourceExportResults = /* GraphQL */ `
  mutation CreateSumBySourceExportResults(
    $input: CreateSumBySourceExportResultsInput!
    $condition: ModelSumBySourceExportResultsConditionInput
  ) {
    createSumBySourceExportResults(input: $input, condition: $condition) {
      id
      client_id
      run_config
      status
      s3_key
      signed_s3_url
      errors
      saved_dt
      createdAt
      updatedAt
    }
  }
`;
